export default {
  container: {
    width: '100%',
    height: '100%',
    borderRadius: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  }
}
